import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
Vue.use(Vuex);
export default new Vuex.Store({
	getters: getters,
	state: {
		token: null,
		tokenExpire: null,
		tagsStoreList: [],
	},
	mutations: {
		saveToken(state, data) {
			state.token = data;
			window.localStorage.setItem("Token", data);
		},
		saveTokenExpire(state, data) {
			state.tokenExpire = data;
			window.localStorage.setItem("TokenExpire", data);
		},
		saveTagsData(state, data) {
			state.tagsStoreList = data;
			sessionStorage.setItem("Tags", data);
		},
		SET_LANGUAGE: (state, language) => {
			state.language = language;
		},
	},
	actions: {
		setLanguage({ commit }, language) {
			commit("SET_LANGUAGE", language);
		},
	},
});
